import { boundSetFeedback } from '../../store/actions/feedback.actions';
import { MESSAGES } from '../../helpers/messages';
import { isOkBrowser } from './isOkBrowser';
import browserList from './lists/browserList';

const userAgentCheck = () => {
  const okBrowser = isOkBrowser(window.navigator.userAgent, browserList);
  if (!okBrowser)
    return boundSetFeedback({
      message: MESSAGES.error.useragent.message,
      isOpen: true,
      modal: {
        title: MESSAGES.error.useragent.title,
        actionButton: MESSAGES.error.useragent.btnText
      }
    });
  return null;
};

export default userAgentCheck;
